import L from "leaflet";
import { useEffect } from "react";
import { useMap } from "react-leaflet";

const FullscreenControl = () => {
  const map = useMap();
  useEffect(() => {
    const FullscreenControlClass = L.Control.extend({
      onAdd: function () {
        const div = L.DomUtil.create("div", "leaflet-bar leaflet-control");
        const button = L.DomUtil.create("a", "", div);

        button.innerHTML = "⛶";
        button.title = "Tela cheia";
        button.style.cssText =
          "width: 30px; height: 30px; line-height: 30px; text-align: center;";

        button.onclick = (e) => {
          e.preventDefault();
          const container = map.getContainer();

          if (!document.fullscreenElement) {
            container.requestFullscreen();
          } else {
            document.exitFullscreen();
          }
        };

        return div;
      },
    });

    const fullscreenControl = new FullscreenControlClass({
      position: "topright",
    });
    fullscreenControl.addTo(map);

    return () => {
      map.removeControl(fullscreenControl);
    };
  }, [map]);

  return null;
};

export default FullscreenControl;
